import { InfoBlock, useTranslator } from "@sia/style-guide";
import { useContext } from "react";
import { WizarContext } from "contexts/WizardContext";

const Summary = () => {
  const translate = useTranslator();
  const { state } = useContext(WizarContext);
  let personalInfo = state.junior.personalInfo;
  let workplaceInfo = state.junior.workplaceInfo;
  let otherAddressesInfo = state.junior.otherAddressesInfo;
  let educationInfo = state.junior.educationInfo;
  let sectionInfo = state.junior.sectionInfo;
  let communicationInfo = state.junior.communicationInfo;

  let newsletters = {
    newsLetterGerman: translate("wizard.form.single.communication.newsletter.german.label"),
    newsLetterFrench: translate("wizard.form.single.communication.newsletter.french.label"),
    siaInformNewsletterDe: translate("wizard.form.single.communication.inform-newsletter.german.label"),
    siaInformNewsletterFr: translate("wizard.form.single.communication.inform-newsletter.french.label"),
    siaInformNewsletterIt: translate("wizard.form.single.communication.inform-newsletter.italian.label"),
  };

  let selectedNewsletter = Object.keys(newsletters).filter((key) => communicationInfo[key]);

  return (
    <div className="summary-info-page">
      <InfoBlock>
        <span className="label">{translate("wizard.form.single.personal-info.gender.label")}</span>
        <p>{personalInfo.gender}</p>
        <span className="label">{translate("wizard.form.single.personal-info.first-name.label")}</span>
        <p>{personalInfo.firstName}</p>
        <span className="label">{translate("wizard.form.single.personal-info.last-name.label")}</span>
        <p>{personalInfo.lastName}</p>
        <span className="label">{translate("wizard.form.single.personal-info.nationality.label")}</span>
        <p>{personalInfo.nationality}</p>
        <span className="label">{translate("wizard.form.single.personal-info.birth-date.label")}</span>
        <p>{personalInfo.dateOfBirth}</p>
        <span className="label">{translate("wizard.form.single.personal-info.language.label")}</span>
        <p>{personalInfo.language.label}</p>
        <span className="label">{translate("wizard.form.single.personal-info.diplom-title.label")}</span>
        <p>{personalInfo.diplomTitle}</p>
        <span className="label">{translate("wizard.form.single.personal-info.academic-title.label")}</span>
        <p>{personalInfo.academicTitle.label}</p>
      </InfoBlock>
      <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">{translate("wizard.form.single.personal-info.address.title")}</p>
      <InfoBlock>
        <span className="label">{translate("wizard.form.single.personal-info.additional-info.label")}</span>
        <p>{personalInfo.additionalInfo}</p>
        <span className="label">{translate("wizard.form.single.personal-info.street.label")}</span>
        <p>{personalInfo.street}</p>
        <span className="label">{translate("wizard.form.single.personal-info.zip.label")}</span>
        <p>{personalInfo.zip}</p>
        <span className="label">{translate("wizard.form.single.personal-info.city.label")}</span>
        <p>{personalInfo.city}</p>
        <span className="label">{translate("wizard.form.single.personal-info.country.label")}</span>
        <p>{personalInfo.country.label}</p>
        <span className="label">{translate("wizard.form.single.personal-info.canton.label")}</span>
        <p>{personalInfo.canton.label}</p>
        {personalInfo.phone && (
          <>
            <span className="label">{translate("wizard.form.single.personal-info.telephone.label")}</span>
            <p>{personalInfo.phone}</p>
          </>
        )}
        {personalInfo.mobile && (
          <>
            <span className="label">{translate("wizard.form.single.personal-info.mobile.label")}</span>
            <p>{personalInfo.mobile}</p>
          </>
        )}
        {personalInfo.email && (
          <>
            <span className="label">{translate("wizard.form.single.personal-info.email.label")}</span>
            <p>{personalInfo.email}</p>
          </>
        )}
      </InfoBlock>
      <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">{translate("wizard.form.single.work-place.current.title")}</p>
      <InfoBlock>
        <span className="label">{translate("wizard.form.single.work-place.new.company.name.label")}</span>
        <p>{workplaceInfo.companyName}</p>
        {workplaceInfo.department && (
          <>
            <span className="label">{translate("wizard.form.single.work-place.new.company.department.label")}</span>
            <p>{workplaceInfo.department}</p>
          </>
        )}

        <span className="label">{translate("wizard.form.single.work-place.new.company.street.label")}</span>
        <p>{workplaceInfo.street}</p>

        <span className="label">{translate("wizard.form.single.work-place.new.company.zip.label")}</span>
        <p>{workplaceInfo.zip}</p>

        <span className="label">{translate("wizard.form.single.work-place.new.company.city.label")}</span>
        <p>{workplaceInfo.city}</p>

        <span className="label">{translate("wizard.form.single.work-place.new.company.country.label")}</span>
        <p>{workplaceInfo.country.label}</p>

        <span className="label">{translate("wizard.form.single.work-place.new.company.canton.label")}</span>
        <p>{workplaceInfo.canton.label}</p>
        {workplaceInfo.phone && (
          <>
            <span className="label">{translate("wizard.form.single.work-place.new.company.telephone.label")}</span>
            <p>{workplaceInfo.phone}</p>
          </>
        )}
        {workplaceInfo.mobile && (
          <>
            <span className="label">{translate("wizard.form.single.work-place.new.company.mobile.label")}</span>
            <p>{workplaceInfo.mobile}</p>
          </>
        )}
        {workplaceInfo.email && (
          <>
            <span className="label">{translate("wizard.form.single.work-place.new.company.email.label")}</span>
            <p>{workplaceInfo.email}</p>
          </>
        )}
      </InfoBlock>
      <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">{translate("wizard.form.single.work-place.activity.label")}</p>
      <InfoBlock>
        <span className="label">{translate("wizard.form.single.work-place.activity.since.label")}</span>
        <p>{workplaceInfo.since}</p>
        <span className="label">{translate("wizard.form.single.work-place.activity.profession.label")}</span>
        <p>{workplaceInfo.profession.label}</p>
        <span className="label">{translate("wizard.form.single.work-place.activity.function.label")}</span>
        <p>{workplaceInfo.jobFunction.label}</p>
        <span className="label">{translate("wizard.form.single.work-place.activity.branch.label")}</span>
        <p>{workplaceInfo.branch.label}</p>
        <span className="label">{translate("wizard.form.single.work-place.activity.activity-area.label")}</span>
        <p>{workplaceInfo.activities.label}</p>
      </InfoBlock>

      <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">{translate("wizard.form.single.summary.deleviry-address.label")}</p>
      <InfoBlock>
        <span className="label">{translate("wizard.form.single.delivery-address.contact.label")}</span>
        <p>{otherAddressesInfo.contact.label}</p>

        <span className="label">{translate("wizard.form.single.delivery-address.deleviry.label")}</span>
        <p>{otherAddressesInfo.delivery.label}</p>

        <span className="label">{translate("wizard.form.single.delivery-address.invoice.label")}</span>
        <p>{otherAddressesInfo.invoice.label}</p>
      </InfoBlock>

      <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">{translate("wizard.form.single.education.bachelor.label")}</p>
      <InfoBlock>
        <span className="label">{translate("wizard.form.single.education.bachelor.school-name.label")}</span>
        <p>{educationInfo.schoolName.label}</p>
        <span className="label">{translate("wizard.form.single.education.bachelor.study-type.label")}</span>
        <p>{educationInfo.studyType.label}</p>
        <span className="label">{translate("wizard.form.single.education.bachelor.earn-date.label")}</span>
        <p>{educationInfo.graduationDate}</p>
        <span className="label">{translate("wizard.form.single.education.bachelor.diplom-title.label")}</span>
        <p>{educationInfo.diplomTitle}</p>
        <span className="label">{translate("wizard.form.single.summary.master.diplom.label")}</span>
        <p>{educationInfo.diplomTitle}</p>
        <span className="label">{translate("wizard.form.single.summary.master.reference.label")}</span>
        <p>{educationInfo.referencesFile[0].file.name}</p>
      </InfoBlock>
      {educationInfo.masterFile &&
        educationInfo.masterTitle &&
        educationInfo.masterGraduationDate &&
        educationInfo.masterStudyType &&
        educationInfo.masterSchoolName && (
          <>
            <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">
              {translate("wizard.form.single.education.further-studies.master.label")}
            </p>
            <InfoBlock>
              <span className="label">{translate("wizard.form.single.education.bachelor.school-name.label")}</span>
              <p>{educationInfo.masterSchoolName.label}</p>
              <span className="label">{translate("wizard.form.single.education.bachelor.study-type.label")}</span>
              <p>{educationInfo.masterStudyType.label}</p>
              <span className="label">{translate("wizard.form.single.education.bachelor.earn-date.label")}</span>
              <p>{educationInfo.masterGraduationDate}</p>
              <span className="label">{translate("wizard.form.single.education.bachelor.diplom-title.label")}</span>
              <p>{educationInfo.masterTitle}</p>
              <span className="label">{translate("wizard.form.single.summary.master.diplom.label")}</span>
              <p>{educationInfo.masterFile[0].file.name}</p>
            </InfoBlock>
          </>
        )}
      <></>
      {educationInfo.doctorateFile &&
        educationInfo.doctorateFile &&
        educationInfo.doctorateGaduationDate &&
        educationInfo.doctorateStudyType &&
        educationInfo.doctorateSchoolName && (
          <>
            <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">
              {translate("wizard.form.single.education.further-studies.doctoral.label")}
            </p>
            <InfoBlock>
              <span className="label">{translate("wizard.form.single.education.bachelor.school-name.label")}</span>
              <p>{educationInfo.doctorateSchoolName.label}</p>
              <span className="label">{translate("wizard.form.single.education.bachelor.study-type.label")}</span>
              <p>{educationInfo.doctorateStudyType.label}</p>
              <span className="label">{translate("wizard.form.single.education.bachelor.earn-date.label")}</span>
              <p>{educationInfo.doctorateGaduationDate}</p>
              <span className="label">{translate("wizard.form.single.education.bachelor.diplom-title.label")}</span>
              <p>{educationInfo.doctorateTitle}</p>
              <span className="label">{translate("wizard.form.single.summary.master.diplom.label")}</span>
              <p>{educationInfo.doctorateFile[0].file.name}</p>
            </InfoBlock>
          </>
        )}
      {sectionInfo.price && (
        <>
          <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">{translate("wizard.form.single.summary.sections.title.label")}</p>
          <InfoBlock>
            <span className="label">{translate("wizard.form.single.summary.sections.label")}</span>
            <p>{sectionInfo.price.label}</p>
            <span className="label">{translate("wizard.form.single.summary.profession.label")}</span>
            <p>{sectionInfo.price.label}</p>
          </InfoBlock>
        </>
      )}
      {(communicationInfo.selectedMagazine || selectedNewsletter.length > 0) && (
        <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">{translate("wizard.form.single.communication.magazins.label")}</p>
      )}
      {communicationInfo.selectedMagazine && (
        <InfoBlock>
          <span className="label">{translate("wizard.form.single.summary.selected.label")}</span>
          <p>{communicationInfo.selectedMagazine}</p>
          <span className="label">{translate("wizard.form.single.summary.format.label")}</span>
          {communicationInfo.magazineFormatEpaper && <p>{translate("subscriptionBox.form.e-paper")}</p>}
          {communicationInfo.magazineFormatPrinted && <p>{translate("subscriptionBox.form.printed")}</p>}
        </InfoBlock>
      )}
      {selectedNewsletter.length > 0 && (
        <InfoBlock>
          <span className="label">{translate("wizard.form.single.summary.selected.label")}</span>
          {selectedNewsletter.map((key) => (
            <p>{translate(newsletters[key])}</p>
          ))}
        </InfoBlock>
      )}
    </div>
  );
};

export default Summary;
